/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowRoundSyncForwardIcon16Light = forwardRef('ArrowRoundSyncForwardIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M6.954 2.027A5.5 5.5 0 0 1 12.4 5H10.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5V2.252a.5.5 0 0 0-1 0v1.784A6.5 6.5 0 0 0 1.09 6.42a.5.5 0 1 0 .986.166 5.5 5.5 0 0 1 4.878-4.56Z" }),
        React.createElement("path", { d: "M4.608 12.178a5.5 5.5 0 0 0 8.313-3.75.5.5 0 1 1 .986.17A6.5 6.5 0 0 1 2 10.963v1.784a.5.5 0 1 1-1 0V9.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1H2.601a5.5 5.5 0 0 0 2.007 2.178Z" })));
});
